import api from "./axios";
import type { User, Household } from "./types";
interface AuthResponse { user: User; token: string; }
export const authService = {
  register: (d: { name: string; email: string; password: string }) => api.post<AuthResponse>("/auth/register", d).then(r => r.data),
  login: (d: { email: string; password: string }) => api.post<AuthResponse>("/auth/login", d).then(r => r.data),
  createHousehold: (name: string) => api.post<Household>("/auth/household", { name }).then(r => r.data),
  joinHousehold: (inviteCode: string) => api.post<User>("/auth/household/join", { inviteCode }).then(r => r.data),
};
